import { render } from "./HeroSidebar.vue?vue&type=template&id=134dd174"
import script from "./HeroSidebar.vue?vue&type=script&lang=js"
export * from "./HeroSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__